import { Component, OnInit } from '@angular/core';
import { Education } from '../../models/education.model';
import { EducationMockService } from '../../services/education-mock.service';

@Component({
  selector: 'bwc-saved-educations',
  templateUrl: './saved-educations.component.html',
  styleUrls: ['./saved-educations.component.scss'],
})
export class SavedEducationsComponent implements OnInit {
  savedEducations: Education[] = [];

  constructor(private educationService: EducationMockService) {}

  ngOnInit(): void {
    this.loadSaved();
  }

  unlike(education: Education): void {
    this.educationService.toggleSaveEducation(education);
    this.loadSaved();
  }

  private loadSaved(): void {
    this.educationService.getSavedEducations().subscribe(e => (this.savedEducations = e));
  }
}
